import React from "react";
import { LineChartLine } from "@ui/IconV2/react";
import type { BlockPlotImportT } from "../../../../../../schema/block/plot";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";
import { createLayerTemplate } from "./layer";

export const icon = () => <LineChartLine size="l" color={colors.carbon800} />;

export const title = t("project.dashboard.block.template.timeseries.title");

export const description = t("project.dashboard.block.template.timeseries.description");

export const layer = createLayerTemplate("line");

export const block: Omit<BlockPlotImportT, "dashboardId" | "position"> = {
  kind: "PLOT",
  data: {
    title: undefined,
    // resources: [],
  },
  config: {
    options: {
      displayInvalidatedDataPoints: false,
      navigator: true,
      sync: true,
    },
    layers: [layer],
  },
};
